
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp"; 
import HomeIcon from '@mui/icons-material/Home';


function CRMobileHeader({ handleMobile }) {
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
    const profileImage = localStorage.getItem("profilPic");
    const userUID = localStorage.getItem("userUID"); 
    const userType = localStorage.getItem("userType");

    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);


    const [userData, setUserData] = useState({
        entityName: "",
        email: "",
        userType: "",
        profilePic: "",
    });

    useEffect(() => {
        const entityName = localStorage.getItem("entityName");
        // const lastName = localStorage.getItem("lastName") ;
        const email = localStorage.getItem("email");
        const userType = localStorage.getItem("userType");
        const profilePic = localStorage.getItem("profilePic");

        setUserData({ entityName, email, userType, profilePic });
    }, []);


    return (
        <div className="menu-mobile-popup">
            <div className="modal-menu__backdrop" onClick={handleMobile}></div>
            <div className="widget-filter">
                <div className="mobile-header align-items-start pb-0">
                    
                    <Link to="#">
                        <img
                            src={profileImage}
                            width={40}
                            alt="User Logo"
                            className="userProfileHeader"
                        />
                    </Link>
                    <ul className="sub-menu st1 p-0">
                        <li>
                            <div className=" d-flex HeaderFLName">
                                <h6> {`${userData.entityName}`}</h6>
                            </div>
                            <div className="HeaderEmail">
                                <h6> {userData.email}</h6>
                            </div>
                            <div className="HeaderUserType">
                                <h6> {userData.userType}</h6>
                            </div>
                        </li>

                    </ul>
                    <Link className="title-button-group close-icon-button-group" onClick={handleMobile}>
                        <i className="icon-close"></i>
                    </Link>
                </div>


                <div className="content-tab">
                    <div className="nav-wrap">
                        <nav className="main-nav mobile">

                            <ul id="menu-primary-menu" className="menu" style={{ paddingLeft: "0px" }}>

                                <li className="menu-item  menu-item-has-children-mobile">

                                    <div className="d-flex align-items-center">
                                        <HomeSharpIcon />
                                        <Link
                                            to="/Home"
                                            className=" ms-2"
                                        >
                                            Home
                                        </Link>
                                    </div>

                                </li>
 
                                <li className="menu-item d-flex align-items-center">
                                    <WorkHistorySharpIcon />
                                    <Link to="/Candidate/All" className="ms-2">Candidates</Link>
                                </li>
                                <li className="menu-item  menu-item-has-children-mobile">
                                    <div className="d-flex align-items-center">

                                        <WorkHistorySharpIcon />
                                        <button
                                            to="#"
                                            className="iteam-menu ms-2"
                                            onClick={() => {
                                                handleToggle("employers");
                                            }}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                color: "inherit",
                                                cursor: "pointer",
                                                padding: 0,
                                                fontWeight: 200,
                                                display: "flex"
                                            }}
                                        >
                                            Manage Job
                                        </button>
                                    </div>
                                    <Collapse isOpened={toggle.key === "employers"}>
                                        <ul
                                            className="sub-menu-mobile ms-2"
                                            style={{
                                                display: `${toggle.key === "employers" ? "block" : "none"
                                                    }`,
                                            }}
                                        >

                                            <li className="menu-item d-flex align-items-center">
                                                {/* <WorkSharpIcon /> */}
                                                <Link to="/job/Add">
                                                    Post Jobs
                                                </Link>
                                            </li>
                                            <li className="menu-item d-flex align-items-center">
                                                {/* <WorkSharpIcon /> */}
                                                <Link to="/job/My-Jobs">
                                                     Jobs List
                                                </Link>
                                            </li>

                                        </ul>
                                    </Collapse>
                                </li>
                                <li className="menu-item  menu-item-has-children-mobile">
                                    <div className="d-flex align-items-center">

                                        <AssignmentSharpIcon />
                                        <button
                                            to="#"
                                            className="iteam-menu ms-2"
                                            onClick={() => {
                                                handleToggle("applications");
                                            }}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                color: "inherit",
                                                cursor: "pointer",
                                                padding: 0,
                                                fontWeight: 200,
                                                display: "flex"
                                            }}
                                        >
                                            Applications
                                        </button>
                                    </div>
                                    <Collapse isOpened={toggle.key === "applications"}>
                                        <ul
                                            className="sub-menu-mobile ms-2"
                                            style={{
                                                display: `${toggle.key === "applications" ? "block" : "none"
                                                    }`,
                                            }}
                                        >
                                            <li className="menu-item d-flex align-items-center">
                                                {/* <WorkSharpIcon /> */}
                                                <Link to="/Applications">
                                                    Manage Applications
                                                </Link>
                                            </li>
                                            <li className="menu-item d-flex align-items-center">
                                                {/* <WorkSharpIcon /> */}
                                                <NavLink to="/Interviews">
                                                    Interviews
                                                </NavLink>
                                            </li>

                                        </ul>
                                    </Collapse>

                                </li>


                                <li className="menu-item d-flex align-items-center">
                                    <AccountCircleSharpIcon />
                                    <Link 
                                    // to="/Profile" 
                                    to={`/${userType}/${userUID}`}
                                    className="ms-2">Profile</Link>
                                </li>

                                <li className="menu-item d-flex align-items-center">
                                    <SettingsSharpIcon />
                                    <Link to="/Settings" className="ms-2">Settings</Link>
                                </li>

                                <li className="menu-item d-flex align-items-center">
                                    <LogoutSharpIcon />
                                    <NavLink
                                        to="/Login"
                                        onClick={() => {
                                            const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
                                            localStorage.clear(); // Clear all localStorage
                                            if (isDarkValue !== null) {
                                                localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
                                            }
                                        }}
                                    >
                                        Logout
                                    </NavLink>
                                </li>


                            </ul>
                        </nav>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default CRMobileHeader;
